import { Position } from 'geojson';

export const hasCoordinates = (coordinates: Position): boolean => {
  const isNullIsland = coordinates?.every((val, _index) => val === 0);
  return !isNullIsland && coordinates !== null && coordinates !== undefined;
};
